// Polyfills for the headless Chromium that react-snap bundles via puppeteer@1.20.0
// (~Chrome 77). Modern browsers already implement these, so this is a no-op for
// real users; it only matters during the static pre-render at build time.
//
// Without Object.hasOwn (Chrome 93+), react-markdown and hast-util-to-jsx-runtime
// throw while rendering blog post bodies, which leaves the pre-rendered HTML with
// only <head> meta/JSON-LD and an empty <div id="root">. See package.json reactSnap.
if (typeof (Object as any).hasOwn !== 'function') {
  (Object as any).hasOwn = function hasOwn(obj: object, prop: PropertyKey): boolean {
    if (obj == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }
    return Object.prototype.hasOwnProperty.call(Object(obj), prop);
  };
}

export {};
